import { TEXTMARKS_BY_TYPE, WORK4ALL_SPECIFIC_TEXTMARKS } from '../constants';
import { Textmark, TextmarkType } from '../types';

type Props = {
  type: TextmarkType;
  isWork4allUser?: boolean;
};

export const useTextmarkData = ({
  type,
  isWork4allUser,
}: Props): Textmark[] => {
  const textmarks = TEXTMARKS_BY_TYPE[type];

  if (!textmarks) {
    throw new Error(`Textmarks for type ${type} is not defined`);
  }

  return Object.keys(textmarks).map((key) => ({
    ...textmarks[key],
    subItems: textmarks[key].subItems.filter(
      (x) => isWork4allUser || !WORK4ALL_SPECIFIC_TEXTMARKS.includes(x.id)
    ) as Textmark[],
  }));
};
